import { render, staticRenderFns } from "./advance.vue?vue&type=template&id=c7854dc4&scoped=true&"
import script from "./advance.vue?vue&type=script&lang=js&"
export * from "./advance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7854dc4",
  null
  
)

export default component.exports